<script setup lang="ts">
import { ConnectionStatus } from '@/shared/lib';

const { status, label } = defineProps<{
  status: ConnectionStatus;
  label: string;
}>();
</script>

<template>
  <aside
    class="fixed top-[max(0.75rem,env(safe-area-inset-top))] left-1/2 z-50 -translate-x-1/2 rounded-full border border-[var(--theme-border-subtle)] bg-[var(--theme-surface-raised)] px-3 py-1.5 text-sm text-[var(--theme-text-primary)] shadow-lg shadow-black/25 backdrop-blur"
    role="status"
    aria-live="polite"
  >
    <span class="flex items-center gap-2 whitespace-nowrap">
      <span
        class="size-2 rounded-full"
        :class="status === ConnectionStatus.OFFLINE ? 'bg-amber-400' : 'animate-pulse bg-sky-400'"
      />
      {{ label }}
    </span>
  </aside>
</template>
